/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import {
    InMerchantNetwork,
    InMerchantNetworkFromJSON,
    InMerchantNetworkFromJSONTyped,
    InMerchantNetworkToJSON,
} from './InMerchantNetwork';
import {
    Merchant,
    MerchantFromJSON,
    MerchantFromJSONTyped,
    MerchantToJSON,
} from './Merchant';
import {
    MerchantStatus,
    MerchantStatusFromJSON,
    MerchantStatusFromJSONTyped,
    MerchantStatusToJSON,
} from './MerchantStatus';

/**
 * 
 * @export
 * @interface MerchantSearchMerchant
 */
export interface MerchantSearchMerchant {
    /**
     * The merchant unique identifier.
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    merchantId: string;
    /**
     * The merchant name.
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    name?: string;
    /**
     * Merchant's name, excluding any location or intersection information
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    nameWithoutLocation?: string;
    /**
     * Nearby major intersection
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    intersection?: string;
    /**
     * List of search tags for this merchant
     * @type {Array<string>}
     * @memberof MerchantSearchMerchant
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Address}
     * @memberof MerchantSearchMerchant
     */
    address?: Address;
    /**
     * 
     * @type {MerchantStatus}
     * @memberof MerchantSearchMerchant
     */
    merchantStatus?: MerchantStatus;
    /**
     * 
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    timezone?: string;
    /**
     * The preferred locale used for communication, in BCP 47 format.
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    locale?: string;
    /**
     * The full ROO menu URL for the merchant
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    menuUrl?: string;
    /**
     * Whether merchant is in the merchant network.
     * @type {boolean}
     * @memberof MerchantSearchMerchant
     */
    inMerchantNetwork?: boolean;
}

export function MerchantSearchMerchantFromJSON(json: any): MerchantSearchMerchant {
    return MerchantSearchMerchantFromJSONTyped(json, false);
}

export function MerchantSearchMerchantFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantSearchMerchant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'merchantId': json['merchantId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nameWithoutLocation': !exists(json, 'nameWithoutLocation') ? undefined : json['nameWithoutLocation'],
        'intersection': !exists(json, 'intersection') ? undefined : json['intersection'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'merchantStatus': !exists(json, 'merchantStatus') ? undefined : MerchantStatusFromJSON(json['merchantStatus']),
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'menuUrl': !exists(json, 'menuUrl') ? undefined : json['menuUrl'],
        'inMerchantNetwork': !exists(json, 'inMerchantNetwork') ? undefined : json['inMerchantNetwork'],
    };
}

export function MerchantSearchMerchantToJSON(value?: MerchantSearchMerchant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'merchantId': value.merchantId,
        'name': value.name,
        'nameWithoutLocation': value.nameWithoutLocation,
        'intersection': value.intersection,
        'tags': value.tags,
        'address': AddressToJSON(value.address),
        'merchantStatus': MerchantStatusToJSON(value.merchantStatus),
        'timezone': value.timezone,
        'locale': value.locale,
        'menuUrl': value.menuUrl,
        'inMerchantNetwork': value.inMerchantNetwork,
    };
}

